module.exports = __webpack_public_path__ + "img/DoughMagic.1b9169ec.jpeg";